import React, { useEffect, useState } from 'react';
import { List, Avatar, Typography, Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import logo1 from '../../../images/logo1.PNG';

const { Text } = Typography;

function BookmarksSectionMessages({ onClose }) {
  const [mensajes, setMensajes] = useState([]);

  useEffect(() => {
    const datos = JSON.parse(localStorage.getItem('mensajesEnviados')) || [];
    setMensajes(datos.reverse()); // Mostrar los más recientes arriba
  }, []);

  return (
    <>
      <Button onClick={onClose} className="sidebar-close-btn">Cerrar</Button>

      <div className="sidebar-notice">
        <Text strong className="notice-title">Aviso:</Text>
        <Text className="notice-text">
          Recuerda encontrarte con el vendedor en lugares seguros. ¡Tu seguridad es lo más importante!
        </Text>
        <Text className="notice-text">
          Asegúrate de revisar el producto antes de realizar el pago.
        </Text>
      </div>

      <Text strong>Mensajes enviados:</Text>

      {mensajes.length > 0 ? (
        <>
          <List
            itemLayout="horizontal"
            dataSource={mensajes}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<Avatar src={item.imagen || logo1} shape="square" />}
                  title={<Text strong>{item.modelo}</Text>}
                  description={
                    <>
                      <div>Número: {item.numero}</div>
                      <div>Fecha: {item.fecha}</div>
                    </>
                  }
                />
              </List.Item>
            )}
          />

          {/* Logo debajo de la lista */}
          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <img 
              src={logo1}
              alt="Mercanteo México"
              style={{ width: '100%', maxWidth: '140px' }}
            />
          </div>
        </>
      ) : (
        <Text style={{ display: 'block', marginTop: 16 }}>
          Aún no has enviado ningún mensaje a vendedores.
        </Text>
      )}
    </>
  );
}

export default BookmarksSectionMessages;
